import React from 'react'
import styled from 'styled-components'

import Heading from '../../Luxkit/Typography/Heading'
import BodyText from '../../Luxkit/Typography/BodyText'

import { rem } from 'polished'
import config from '../../../constants/config'
import ImageHero from '../../Common/ImageHero'
import SearchForm, { SearchFormRef } from 'components/Search/SearchForm'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES } from 'constants/search'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import DestinationProductPageMobileSearchFrom
  from 'components/Pages/DestinationProductPage/DestinationProductPageMobileSearchFrom'
import Group from 'components/utils/Group'
import cn from 'clsx'

interface Props {
  title: string
  subheading: string
  searchFormEnabled: boolean
  filters: App.OfferListFilters
  formRef: React.RefObject<SearchFormRef | null>
}

const ContentContainer = styled(ImageHero)`
  position: relative;
  max-height: ${rem(200)};

  &.large {
    color: ${props => props.theme.palette.neutral.default.one};
    max-height: ${rem(352)};

    ${mediaQueryUp.tablet} {
      max-height: ${rem(504)};
    }
    ${mediaQueryUp.desktop} {
      max-height: ${rem(400)};
    }
  }
`

const Container = styled(Group)`
  position: relative;
`

const DesktopSearchFromContainer = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(20)} ${rem(32)} ${rem(16)};
  width: ${rem(600)};

  ${mediaQueryUp.desktop} {
    width: ${rem(890)};
  }

  ${mediaQueryUp.largeDesktop} {
    width: ${rem(1108)};
  }
`

const MobileSearchFromContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(32)};

  position: absolute;
  bottom: -${rem(46)};
`

const SearchContainer = styled.div`
  background: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: ${(props) => props.theme.shadow.flat.small};
  padding: ${rem(16)};
  width: ${rem(336)};
`

function DestinationProductPageHeader({ title, subheading, searchFormEnabled, filters, formRef }: Props) {
  return (
    <Container direction="vertical" horizontalAlign="center">
      <ContentContainer id={config.searchFormSection.hotelsImageId} brightness={-30} mobileWidth="100vw" dpr={2} className={cn({ large: searchFormEnabled })}>
        {!searchFormEnabled && <Heading variant="heading2" colour="neutral-eight" as="h1">{title}</Heading>}
        {!searchFormEnabled && <BodyText variant="large" colour="neutral-eight" as="h2" align="center">{subheading}</BodyText>}
        {searchFormEnabled && (
          <CSSBreakpoint min="tablet">
            <Group gap={32} direction="vertical" horizontalAlign="center">
              <Heading variant="heading2" colour="neutral-eight" as="h1">{title}</Heading>
              <DesktopSearchFromContainer>
                <SearchForm
                  submitOnApply
                  filters={filters}
                  ref={formRef}
                  showDateFieldOnMobile={false}
                  typeaheadTypes={HOTEL_SEARCH_TYPEAHEAD_TYPES}
                />
              </DesktopSearchFromContainer>
            </Group>
          </CSSBreakpoint>
        )}
      </ContentContainer>
      {searchFormEnabled &&
        <CSSBreakpoint max="mobile" as={MobileSearchFromContainer}>
          <Heading variant="heading2" colour="neutral-eight" as="h1" align="center">{title}</Heading>
          <SearchContainer>
            <DestinationProductPageMobileSearchFrom filters={filters}/>
          </SearchContainer>
        </CSSBreakpoint>
      }
    </Container>
  )
}

export default DestinationProductPageHeader
